import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'driftwood',
      d: 'M1.5,-2.5h0.5v0.5h-0.5zM1,-2h1v0.5h-1zM-2.5,-1.5h2.5v0.5h-2.5zM0.5,-1.5h1.5v0.5h-1.5zM-3.5,-1h3v0.5h-3zM0,-1h2v0.5h-2zM-3.5,-0.5h7.5v0.5h-7.5zM-3.5,0h1v0.5h-1zM0.5,0h3.5v0.5h-3.5z',
    },
    { paint: 'trunk', d: 'M-4,-1h0.5v1.5h-0.5zM-0.5,-1h0.5v0.5h-0.5z' },
  ],
  pixels: 49,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
